import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Tab, TabPane } from 'semantic-ui-react';
import { CloudStorageService } from '~/api/services/cloudStorage';
import { FormFields } from '~/components/FormFields';
import Layout from '~/components/Layout';
import { El } from '~/components/Layout/style';
import notify from '~/components/Notify';
import { RouteTypes } from '~/routes/constants';

const CloudStorage: React.FunctionComponent = () => {
  const { t } = useTranslation()
  const [options, setOptions] = useState(null)
  const [isBusy, setIsBusy] = useState(false)
  const navigate = useNavigate()
  const [activeIndex, setActiveIndex] = useState<string | number>(0);

  const { control, handleSubmit, reset, watch } = useForm({
    mode: 'onSubmit'
  })

  const watchFarmerEnabled = watch('farmerEnabled')

  useEffect(() => {
    fetchData()
  }, [])

  async function fetchData() {
    setIsBusy(true);
    try {
      const responseOptions = await CloudStorageService.getOptionsSettingsCloudStorage()
      const responseEdit = await CloudStorageService.getDataSettingsCloudStorage()
      setOptions(responseOptions.data)
      responseOptions.data.languages.map((language) => {
        const index = responseEdit?.data?.texts[0].languages.findIndex(
          (languageText) => languageText.id === language.id
        );
        if (index < 0) {
          responseEdit?.data?.texts[0]?.languages.push({
            ...language,
            id: language.id,
            translation: '',
            slug: 'cloud_storage_text'
          });
        }
      });
      reset(responseEdit.data)
    } catch (error) {
      if (error?.response?.data) {
        notify(error?.response?.data?.message, 'error');
      } else {
        notify(t('General error'), 'error');
      }
    }
    setIsBusy(false);
  }

  async function onSubmit(data) {
    setIsBusy(true);
    try {
      await CloudStorageService.updateSettingsCloudStorage(data)
      notify(t('Successfully  updated cloud storage settings'), 'success');
    } catch (error) {
      if (error?.response?.data) {
        notify(error?.response?.data?.message, 'error');
      } else {
        notify(t('General error'), 'error');
      }
    }
    setIsBusy(false);
  }

  function renderFormContentArea(index, languageOptions) {
    const indexLanguage = options?.languages.findIndex(
      (language) => language.id === languageOptions.id
    );
    return (
      <>
        <FormFields.Input
          key={languageOptions.id}
          placeholder={t('Title')}
          control={control}
          width={8}
          rules={{
            required: {
              value: watchFarmerEnabled === 1,
              message: t('Please enter title')
            }
          }}
          name={`texts[0].languages[${indexLanguage}].translation`}
        />
      </>
    );
  }

  function renderForm() {
    return <>
      <FormFields.Checkbox
        control={control}
        style={{ margin: '1em' }}
        defaultValue={0}
        checkboxValue={1}
        name={'farmerEnabled'}
        label={t('Cloud storage activated for farmers')}
      />
      <Tab
        menu={{ secondary: true, pointing: true }}
        activeIndex={activeIndex}
        renderActiveOnly={false}
        onTabChange={(_, data) => setActiveIndex(data.activeIndex)}
        panes={options?.languages?.map((language, index) => {
          return {
            menuItem: options?.languages[index]?.label || null,
            pane: <TabPane
              active={index === activeIndex}
              style={{ border: 'none', marginBottom: 0, marginLeft: 0 }}
              key={language.id}
            >
              {renderFormContentArea(index, language)}
            </TabPane>
          };
        })}
      />
    </>
  }

  function renderActions() {
    return <>
      <El.PageHeaderActionButton
        type={'button'}
        onClick={() => navigate(RouteTypes.CLOUD_STORAGE)}
      >{t('Cloud storage')}</El.PageHeaderActionButton>
      <El.PageHeaderActionButton
      >{t('Update')}</El.PageHeaderActionButton>
    </>
  }

  return (
    <Layout
      title={t('Cloud Storage settings')}
      isBusy={isBusy}
      segmented
      actions={renderActions()}
      onSubmit={handleSubmit(onSubmit)}
    >
      {renderForm()}
    </Layout>
  );
};

export default CloudStorage;
